// export var apiurl = "http://localhost:8000/";
// export var fileurl = "http://localhost:8000";

// export var apiurl = "https://api.m2m.bonvoice.com/";
// export var fileurl = "https://api.m2m.bonvoice.com";


export var apiurl = "https://api.m2m.doware.in/";
export var fileurl = "https://api.m2m.doware.in";